
import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { getNews } from "../../app/api";
import { useNavigate } from "react-router-dom";



const HTMLTextView = ({ htmlContent }: any) => {
    return (
        <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
};


const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1240,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 940,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true,
            },
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: true,
            },
        },
    ],
};





const NewsSlider = () => {
    const [Data, setData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        try {
            const q = {
            offset: "0",
            limit: "8",
            }
            const params = new URLSearchParams(q);
          
            getNews(params).then((res) => {
                if(res) {
                    setData(res.data.results);
                }
            });
        } catch(err) {
        }
    }, []);

    return (
        <div className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight text-[#003463] sm:text-4xl italic mb-4">
                        Мэдээ, мэдээлэл
                    </h2>
                </div>
                <div>
                    <div>
                        {Data.length <= 3 ?
                            <div className="flex flex-wrap justify-center">

                                {Data.map((post: any) => (
                                    <div
                                        key={post.id}
                                        onClick={() => navigate(`/news/${post.id}`)}
                                        className="w-80 items-start justify-center px-3 cursor-pointer"
                                    >
                                        <div className="w-full">
                                            <div className="relative w-full">

                                                {post.type === "Зураг" || post.type === "Бичлэг" ?
                                                    <p className="absolute right-0 bg-[#07B2EC] px-4 rounded-2xl text-white mt-2 mr-2">
                                                        {post.type}
                                                    </p> :
                                                    <p className="absolute right-0 bg-[#FF4433] px-4 rounded-2xl text-white mt-2 mr-2">
                                                        {post.type}
                                                    </p>
                                                }
                                                <img
                                                    loading="lazy"
                                                    src={post.thumb}
                                                    alt="image"
                                                    className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                                                />
                                                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                                            </div>
                                            <div className="max-w-xl">
                                                <div className="group relative">
                                                    <h3 className="mt-3 text-lg font-semibold leading-6 text-[#003463] ">
                                                        {post.title}
                                                    </h3>
                                                    <p className="mt-5 custom-line-clamp text-sm leading-6 text-[#001447]">
                                                        <HTMLTextView htmlContent={post.content} />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div> :
                            <Slider {...settings}>
                                {Data.map((post: any) => (
                                    <div
                                        key={post.id}
                                        onClick={() => navigate(`/news/${post.id}`)}
                                        className="w-80 items-start justify-center px-3 cursor-pointer"
                                    >
                                        <div className="w-full">
                                            <div className="relative w-full">

                                                {post.type === "Зураг" || post.type === "Бичлэг" ?
                                                    <p className="absolute right-0 bg-[#07B2EC] px-4 rounded-2xl text-white mt-2 mr-2">
                                                        {post.type}
                                                    </p> :
                                                    <p className="absolute right-0 bg-[#FF4433] px-4 rounded-2xl text-white mt-2 mr-2">
                                                        {post.type}
                                                    </p>
                                                }
                                                <img
                                                    loading="lazy"
                                                    src={post.thumb}
                                                    alt="image"
                                                    className="aspect-[16/9] w-full rounded-2xl bg-gray-100 object-cover sm:aspect-[2/1] lg:aspect-[3/2]"
                                                />
                                                <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-gray-900/10" />
                                            </div>
                                            <div className="max-w-xl">
                                                <div className="group relative">
                                                    <h3 className="mt-3 text-lg font-semibold leading-6 text-[#003463] ">
                                                        {post.title}
                                                    </h3>
                                                    <p className="mt-5 custom-line-clamp text-sm leading-6 text-[#001447]">
                                                        <HTMLTextView htmlContent={post.content} />
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewsSlider;
